<div>
    <div class="nav flex-start-center gap-x-3 py-2 px-1 overflow-x-auto mb-1">
        <button nz-button [ngClass]="{'not-active': index !== 0}" (click)="switchTab(0)">Traits</button>
        <button nz-button [ngClass]="{'not-active': index !== 1}" (click)="switchTab(1)">Portfolio</button>
        <button nz-button [ngClass]="{'not-active': index !== 2}" (click)="switchTab(2)">
            {{'NFTs' + (nftsComponent.totalNFTCount > 0 ? ' (' + nftsComponent.totalNFTCount + ')' : '')}}
        </button>
        <button nz-button [ngClass]="{'not-active': index !== 3}" (click)="switchTab(3)">Transactions</button>
        <button nz-button [ngClass]="{'not-active': index !== 4}" (click)="switchTab(4)">
            {{'Badges' + ((badgesComponent.badges?.length) > 0 ? ' (' + (badgesComponent.badges?.length) + ')' : '')}}
        </button>
    </div>

    <nz-tabset [(nzSelectedIndex)]="index">
        <nz-tab>
            <app-address-features [walletAddress]="walletAddress"></app-address-features>
        </nz-tab>
        <nz-tab>
            <app-address-portfolio [walletAddress]="walletAddress"></app-address-portfolio>
        </nz-tab>
        <nz-tab>
            <app-address-nfts #nftsComponent [pageType]="pageType" [walletAddress]="walletAddress"></app-address-nfts>
        </nz-tab>
        <nz-tab>
            <app-address-transactions [pageType]="pageType" [walletAddress]="walletAddress" [maxCount]="maxCount"></app-address-transactions>
        </nz-tab>
        <nz-tab>
            <app-address-badges #badgesComponent [walletAddress]="walletAddress" [pageType]="pageType" [walletProfile]="walletProfile"></app-address-badges>
        </nz-tab>
    </nz-tabset>
</div>
